
import { call, put, takeEvery } from "redux-saga/effects";
import { giaiDoanApi } from "../../../api/ke-hoach/giaiDoanApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IGiaiDoan } from "../../../model/respone/ke-hoach/IGiaiDoan";
import { eGiaiDoanActionIds, IGiaiDoanActionTypes } from "../../action-types/ke-hoach/IGiaiDoanActions";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
const mainAction = rootActions.keHoach.giaiDoan;
export function* giaiDoanSaga(): any {
    yield takeEvery(eGiaiDoanActionIds.LOAD_START, loadWorker)
    yield takeEvery(eGiaiDoanActionIds.SAVE_START, saveWorker)
    yield takeEvery(eGiaiDoanActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IGiaiDoanActionTypes): any {
    const res: IBaseRespone = yield call(giaiDoanApi.SelectByNamHoc, action.payload as string)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: IGiaiDoanActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as IGiaiDoan
    if (payload.id > 0) {
        res = yield call(giaiDoanApi.Update, payload)
    } else {
        res = yield call(giaiDoanApi.Insert, payload)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: IGiaiDoanActionTypes): any {
    const res: IBaseRespone = yield call(giaiDoanApi.Deletes, action.payload as IIdsRequest)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}